export default __webpack_public_path__ + "static/media/bannerMb.d7acb188.png";